import './Empty.scss';

import {
  AlignItems,
  CButton,
  CButtonProps,
  CFlex,
  CSpacing,
  CText,
  CTextAlign,
  CTextColor,
  CTextSize,
  CTextWeight,
  FlexDirection,
  JustifyContent,
} from '@dark-portal/react-components';
import { PropsWithChildren } from 'react';

interface Props {
  title: string;
  subtitle?: string;
  testSelector?: string;
  action?: CButtonProps;
}

export const EmptyScreen = (props: PropsWithChildren<Props>) => {
  return (
    <CFlex
      testSelector={props.testSelector}
      direction={FlexDirection.Column}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.Center}
      gap={CSpacing.Lg}
      class="screen--empty"
    >
      <div className="screen__image" aria-hidden="true">
        {props.children}
      </div>

      <CText align={CTextAlign.Center} size={CTextSize.Xxlg} weight={CTextWeight.SemiBold}>
        {props.title}
      </CText>

      {props.subtitle && (
        <CText align={CTextAlign.Center} size={CTextSize.Sm} color={CTextColor.Gray4}>
          {props.subtitle}
        </CText>
      )}

      {props.action && (props.action.text || props.action.left) && <CButton {...props.action} />}
    </CFlex>
  );
};
